import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_COURSE, UPDATE_COURSE } from './constants';
import {
  loadCourseSuccess,
  loadCourseError,
  updateCourseSuccess,
  updateCourseError,
} from './actions';

import history from 'utils/history';
import requestUtil from 'utils/request';
import requestWrapper from 'utils/requestWrapper';

// utils
import api from "utils/api";
const { endpoint } = api;
import _local from 'utils/localStorageUtils';


export function* loadCourseSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;
    const { id, onDate, timeZone } = action;
    const isTeacher = role == 'teacher';

    let finalEndpoint = endpoint?.courses?.single(id);
    if (role == 'teacher') {
      finalEndpoint = endpoint?.courses?.teacher?.single(id);
    } else if (role == 'parent') { 
      finalEndpoint = endpoint?.courses?.parent?.single(id);
    } 

    // we get the campaigns linked to the courses
    let courseDetailSaga = yield requestWrapper(
      isTeacher ? 'POST' :'GET',
      finalEndpoint,
      {
        onDate, timeZone
      },
      currentUser.token,
    );

    if (!courseDetailSaga) {
      yield put(loadCourseSuccess(false));
    } else {
      yield put(loadCourseSuccess(courseDetailSaga, isTeacher));
    }
  } catch (error) {
    yield put(loadCourseError(error));
  }
}

export function* updateCourseSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { courseDetail } = action;

    let updatedCourse = false,
      isNew = !courseDetail?._id;

    if (isNew) {
      updatedCourse = yield requestWrapper(
        'POST',
        endpoint?.courses?.new,
        courseDetail,
        currentUser.token,
      );
    } else {
      updatedCourse = yield requestWrapper(
        'PATCH',
        endpoint?.courses?.update,
        courseDetail,
        currentUser.token,
      );
    }

    if (!updatedCourse) {
      yield put(updateCourseSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/сours/${updatedCourse._id}` });
      }
      yield put(updateCourseSuccess(updatedCourse));
    }
  } catch (err) {
    yield put(updateCourseError(true));
  }
}

// Individual exports for testing
export default function* courseDetailMobileSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COURSE, loadCourseSaga);
  yield takeLatest(UPDATE_COURSE, updateCourseSaga);
}
